import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { Badge, StyledLockClockBadge } from './upcoming-offer.styled';

const UpcomingOfferBadge: FC = props => {
  const { formatMessage } = useIntl();

  return (
    <Badge {...props}>
      <StyledLockClockBadge />
      {formatMessage({ id: 'comingSoon' })}
    </Badge>
  );
};

export default UpcomingOfferBadge;
